'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle } from '@subframe/core';
import type { FormatoDownload } from '../../types/baixarProcesso.types';
interface EtapaFalhaGeracaoProps {
  erroGeracao: string | null;
  /** O documento passou do limite: repetir o mesmo pedido falha igual. */
  falhouPorLimite: boolean;
  formato: FormatoDownload | null;
}

/**
 * O que fazer depois da falha. No limite, "tente de novo" mandaria repetir o que não tem como dar
 * certo: o completo e o ZIP (que é o completo dividido) são o mesmo documento, então a saída é um
 * recorte menor.
 */
function proximoPasso(falhouPorLimite: boolean, formato: FormatoDownload | null): string {
  if (!falhouPorLimite) return 'Nada foi perdido no processo. Tente novamente em instantes.';
  if (formato === 'secoes') return 'Marque menos seções para um documento menor.';
  return 'O PDF completo e o ZIP são o mesmo documento e os dois passam do limite. Baixe só as seções de que precisa.';
}
export function EtapaFalhaGeracao(t0) {
  const $ = _c(12);
  const {
    erroGeracao,
    falhouPorLimite,
    formato
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherAlertTriangle className="text-error-700 mt-px h-[17px] w-[17px] flex-none" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-error-800 text-[13.5px] font-semibold">Não foi possível montar o pacote</span>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = erroGeracao ?? "A montagem parou no meio. Nada foi perdido no processo.";
  let t4;
  if ($[2] !== t3) {
    t4 = <div className="border-error-200 bg-error-50 flex items-start gap-3 rounded-[12px] border border-solid px-[18px] py-4" role="alert">{t1}<div className="flex flex-col gap-[3px]">{t2}<span className="text-error-700 text-[12.5px] leading-[1.6]">{t3}</span></div></div>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== falhouPorLimite || $[5] !== formato) {
    t5 = proximoPasso(falhouPorLimite, formato);
    $[4] = falhouPorLimite;
    $[5] = formato;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className="flex flex-col gap-2.5 rounded-[12px] bg-neutral-50 px-[18px] py-4"><span className="text-[12.5px] leading-[1.6] text-neutral-600">{t5}</span></div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <div className="flex w-full flex-col gap-4 px-6 pt-1 pb-6">{t4}{t6}</div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}